import React from 'react'
import { Form, FormItemProps } from 'antd'
import cl from 'classnames'

import styles from './formItem.module.scss'

type Props = FormItemProps & {
	error?: boolean
	validate?: boolean
	helpMessage?: BasicString
	errorMessage?: string
	name: string
}

const FormItem: React.FC<Props> = ({
	className,
	error,
	validate,
	children,
	helpMessage,
	errorMessage,
	name,
	...props
}) => {
	return (
		<Form.Item
			{...props}
			className={cl(styles.formItemWrapper, className, {
				'ant-form-item-has-error': error,
				'ant-form-item-is-validated': validate
			})}
			validateStatus={error ? 'error' : 'success'}
			help={error ? errorMessage : helpMessage}
			data-testid={`qaa-${name}`}
		>
			{children}
		</Form.Item>
	)
}

export default FormItem
